export default __webpack_public_path__ + "static/media/alert-warning.0cb03e96.svg";